'use client';

import Image from 'next/image';
import styled from 'styled-components';

const AvatarContainer = styled.div`
  position: relative;
  display: flex;
`;

const AvatarCircle = styled.div`
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border-radius: 50%;
  overflow: hidden;
  &:hover {
    top: -6px;
    left: 6px;
    border: 6px solid var(--blue);
  }
`;

const Avatar = ({
  src = 'https://adexkoudxzpctopifmie.supabase.co/storage/v1/object/public/avatars/default-avatar.png',
  width = '55',
  height = '55'
}) =>
  src && (
    <AvatarContainer>
      <AvatarCircle width={width} height={height}>
        <Image width={width} height={height} src={src} alt="Profile Pic" />
      </AvatarCircle>
    </AvatarContainer>
  );
export default Avatar;
